// extracted by mini-css-extract-plugin
module.exports = {"profile-img-small":"ProfileIcon_profile-img-small__36lag","profile-img-large":"ProfileIcon_profile-img-large__uEkER","profile-img-arrow":"ProfileIcon_profile-img-arrow__3ufTA"};